export default __webpack_public_path__ + "/dist/images/ship-icon.06f481366b1db0c4d6067e8af01d8160.svg";